import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Space } from '../../../ds';
import styled from 'styled-components';

const ModalBody = styled(Space)`
  text-align: center;
`;

const ModalCancel = ({
  isOpen = false,
  onClose = () => null,
  onClick = () => null,
}) => {
  return (
    <Modal
      theme='dark'
      className='modal-size'
      cardType='secondary'
      onClose={onClose}
      onOverlayClick={onClose}
      {...{ isOpen: isOpen }}
      showClose
    >
      <div className='k-ds-width-full'>
        <Space className='k-ds-heading-04 k-ds-m-top-sp-06' justify='center'>
          Vas a cancelar esta venta
        </Space>
        <ModalBody className='k-ds-m-top-sp-02' justify='center' align='center'>
          Si cancelas, se anulará la venta y el cliente deberá reiniciar el
          proceso de compra.
        </ModalBody>
        <Space className='k-ds-m-top-sp-03' justify='center'>
          <Button
            type='primary-alternate'
            className='k-ds-m-top-sp-06'
            size='large'
            onClick={() => onClick()}
          >
            Cancelar venta
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

ModalCancel.propTypes = {
  isOpen: PropTypes.bool,
  message: PropTypes.string,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
};

export default ModalCancel;
